var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.3796 4.26105H18.108L17.058 2.07999C16.5756 1.04841 15.554 0.399994 14.4472 0.399994H11.4675C10.3607 0.399994 9.36747 1.04841 8.85666 2.07999L7.80666 4.26105H1.56342C0.939092 4.26105 0.399902 4.79157 0.399902 5.46947C0.399902 6.14736 0.910713 6.67789 1.56342 6.67789H3.01071L5.30936 25.8947C5.47963 27.3389 6.64315 28.4 8.06206 28.4H17.9094C19.2999 28.4 20.4634 27.3095 20.6621 25.8947L22.9891 6.67789H24.4364C25.0607 6.67789 25.5999 6.14736 25.5999 5.46947C25.5999 4.79157 25.0323 4.26105 24.3796 4.26105ZM10.9283 3.14105C11.0418 2.93473 11.2404 2.78736 11.4675 2.78736H14.4472C14.6742 2.78736 14.9013 2.93473 14.9864 3.14105L15.5256 4.29052H10.3891L10.9283 3.14105Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/TrashIcon.2f376d020ed86551fa8785ce045b6254.svg";
export { ForwardRef as ReactComponent };